import RelatedNews from './components/RelatedNews'
import NewsBrowser from './components/newsbrowser/NewsBrowser'
import TabComponent from './components/TabComponent'
import GalleryBrowser from './components/gallery-browser/GalleryBrowser'
import EmbeddedGallery from './components/gallery-browser/EmbeddedGallery'
import initShareFunctions from './components/shareFunction'
import translation from './mixins/translation'
import calendar from './mixins/calendar'

import VueScrollTo from 'vue-scrollto'
import Multiselect from 'vue-multiselect'
import { Dropdown, Menu } from 'v-tooltip'
import VTooltip from 'v-tooltip'

import { Calendar, DatePicker } from 'v-calendar'

import CalendarFiltersComponent from './components/admin/CalendarFiltersComponent'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('slick-carousel')

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.zen-page-header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.zen-page-header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('.zen-page-header').removeClass('nav-up').addClass('nav-down');
        }
    }

    lastScrollTop = st;
}

window.Vue = require('vue').default;

Vue.mixin(translation)
Vue.mixin(calendar)

Vue.use(VueScrollTo, {
    container: "body",
    duration: 600,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.use(VTooltip)

const files = require.context('./components/calendar', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('multiselect', Multiselect)

Vue.component('v-dropdown', Dropdown)
Vue.component('v-menu', Menu)

Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

Vue.component('related-news', RelatedNews)

Vue.component('news-browser', NewsBrowser)
Vue.component('gallery-browser', GalleryBrowser)
Vue.component('embedded-gallery', EmbeddedGallery)
Vue.component('pagination', require('laravel-vue-pagination'))

Vue.component('calendar-filters-component', CalendarFiltersComponent)
Vue.component('tab-component', TabComponent)

import homePageCarousels from './components/homePageCarousels'
import setupContentCarousel from './components/contentCarousel'

const app = new Vue({
    el: '#app',
});

initShareFunctions()
homePageCarousels()
setupContentCarousel()

import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

var elements = document.getElementsByClassName('content-component-lightbox');
for (let item of elements) {
    lightGallery(item, {
        speed: 500,
        selector: '.slide-item',
        // Append caption inside the slide item
        // to apply some animation for the captions (Optional)
        appendSubHtmlTo: ".lg-item",
        // Delay slide transition to complete captions animations
        // before navigating to different slides (Optional)
        // You can find caption animation demo on the captions demo page
        slideDelay: 400,
        licenseKey: '0A003BB3-3039466A-918940DD-C83982AE',
        nextHtml : '<svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg>',
        prevHtml : '<svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg>'
    })
}

var elements = document.getElementsByClassName('content-component-lightbox-thumbnails');
for (let item of elements) {
    lightGallery(item, {
        speed: 500,
        plugins: [lgThumbnail, lgZoom],
        thumbnail: true,
        selector: '.slide-item',
        // Append caption inside the slide item
        // to apply some animation for the captions (Optional)
        appendSubHtmlTo: ".lg-item",
        // Delay slide transition to complete captions animations
        // before navigating to different slides (Optional)
        // You can find caption animation demo on the captions demo page
        slideDelay: 400,
        licenseKey: '0A003BB3-3039466A-918940DD-C83982AE',
        nextHtml : '<svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg>',
        prevHtml : '<svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg>'
    })
}

$(document).ready(function(){
    $(".img-parallax img").paroller({ factor: -0.05, factorXs: -0.16, factorSm: -0.26, type: 'foreground', direction: 'vertical' });
    setTimeout(function(){
        $(document).trigger('scroll');
    },100);



    $('.content-component-quote:not(.expanded) .supporter-limit-text').each(function(){
        var wrapper = $(this).outerHeight();
        var text = $(this).find('.limited-text').outerHeight();

        if (text > wrapper) {
            $(this).closest('.content-component-quote').addClass('isLimited')
        } else {
            $(this).closest('.content-component-quote').removeClass('isLimited')
        }
    });
})

window.toggleSlickAutoplay = function (element, slick) {
    $(element).toggleClass('pause');

    $(slick).toggleClass('slick-pause');
    $(slick).slick($(slick).hasClass('slick-pause') ? 'slickPause' : 'slickPlay');

    if (!$(slick).hasClass('slick-pause')) {
        $(slick).slick('slickNext');
    }
}

window.showSlickNext = function (slick) {
    $(slick).slick('slickNext');
}

window.showSlickPrev = function (slick) {
    $(slick).slick('slickPrev');
}
